import { SagaIterator } from 'redux-saga';
import { all, fork } from 'redux-saga/effects';
import { rootStartersSaga } from '../../starters/sagas/StartersSagas';
import { rootUploadContentSaga } from '../../uploadContent/sagas/UploadContentSaga';
import { rootDisplayModeSaga } from './DisplayModeSaga';
import { rootRequestFailedSaga } from './RequestFailedSaga';
import { rootAvailableActionsForEntitySaga } from './spaces/AvailableActionsForEntitySagas';
import { rootSpacesSaga } from './spaces/RootSpacesSaga';
import { rootSiteSagas } from './spaces/SitesSagas';

export function* rootSaga(): SagaIterator {
  yield all([
    fork(rootDisplayModeSaga),
    fork(rootSpacesSaga),
    fork(rootRequestFailedSaga),
    fork(rootAvailableActionsForEntitySaga),
    fork(rootSiteSagas),
    fork(rootStartersSaga),
    fork(rootUploadContentSaga)
  ]);
}
